function initialState() {
  return {
    quickScheduleData: {}
  };
}

const getters = {
  quickScheduleData: (state) => state.quickScheduleData
};

const mutations = {
  SET_QUICK_SCHEDULE_DATA(state, payload) {
    state.quickScheduleData = payload;
  },
  RESET_QUICK_SCHEDULE_DATA(state) {
    const initial = initialState();

    Object.keys(initial).forEach((key) => {
      state[key] = initial[key];
    });
  }
};

const actions = {
  setQuickScheduleData({ commit }, payload) {
    commit('SET_QUICK_SCHEDULE_DATA', payload);
  },
  resetQuickScheduleData({ commit }) {
    commit('RESET_QUICK_SCHEDULE_DATA');
  }
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions
};
